export const theme = {
  defaultfontSize: '16px',
  defaultFontFamily: 'Work Sans',
  headerFontFamily: 'Roboto',
  defaultFontColor: '#333',
  secondaryFontColor: '#5b5c5c',
  primaryAccentColor: '#555',
  boldAccentColor: '#2b2a74',
  boldAccentColor_hover: '#403f6d',
  brightAccentColor: '#555',
  darkBackgroundColor: '#282F35',
  lightBackgroundColor: '#efefef',
  greyColor: '#aaa',
  greyColorHover: '#999'
};
